export default __webpack_public_path__ + "static/media/DSC_0554.bd23a251.jpg";